import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import { Map } from 'immutable'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import Link from '../Link/index'
import { H3 } from '../Heading/index'
import { getBoundActions } from '../../actions/index'
import { selectSeries } from '../../services/node/index'
import { TYPE_CONTENT_SERIES } from '../../services/content-type/index'
import { CLICK_TO_DETAILS_PAGE_GA4_EVENT } from '../../services/event-tracking/index'

const TitleSeriesVideo = (props) => {
  const {
    video,
    series,
    page,
    linkClass = '',
    titleClass = '',
    hasHeader,
    getSeries,
  } = props

  const seriesId = video.getIn(['data', 'seriesId'], '')
  const pageLang = page.get('lang', 'en')
  const seriesData = (series && series.size > 0) && series.getIn([`${seriesId}`, pageLang], Map())
  const seriesUrl = (seriesData && seriesData.size > 0) ? seriesData.getIn(['data', 'url'], '') : ''
  const seriesTitle = (seriesData && seriesData.size > 0) ? seriesData.getIn(['data', 'title'], '') : ''
  const seriesDetailsEventData = seriesData && seriesData.size > 0
    ? CLICK_TO_DETAILS_PAGE_GA4_EVENT.mergeDeep({
      content_id: seriesData.getIn(['data', 'id']),
      content_name: seriesData.getIn(['data', 'title']),
      content_type: TYPE_CONTENT_SERIES,
      media_language: seriesData.getIn(['data', 'mediaLanguage']),
      is_featured_media: true,
      ui_location: hasHeader ? 'Video Player' : 'End Screen',
      ui_element: 'Title',
    })
    : null

  useEffect(() => {
    getSeries({ ids: [seriesId], language: pageLang })
  }, [getSeries, seriesId, pageLang])

  return (
    <Link
      to={seriesUrl}
      className={`video-series-title__link-container ${linkClass}`}
      ga4EventData={seriesDetailsEventData}
    >
      {hasHeader
        ? <H3 inverted className={titleClass}>{seriesTitle}</H3>
        : <div>{seriesTitle}</div>
      }
    </Link>
  )
}

TitleSeriesVideo.propTypes = {
  getSeries: PropTypes.func,
  series: PropTypes.object,
  video: PropTypes.object,
  page: PropTypes.object,
  linkClass: PropTypes.string,
  titleClass: PropTypes.string,
  hasHeader: PropTypes.bool,
}

export default compose(
  connectRedux(
    (state) => {
      const { video, page } = state
      return {
        video,
        page,
        series: selectSeries(state),
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        getSeries: actions.node.getSeries,
      }
    },
  ),
)(TitleSeriesVideo)
